import { render, staticRenderFns } from "./kaijiang.vue?vue&type=template&id=1635b7a2&scoped=true"
import script from "./kaijiang.vue?vue&type=script&lang=js"
export * from "./kaijiang.vue?vue&type=script&lang=js"
import style0 from "./kaijiang.vue?vue&type=style&index=0&id=1635b7a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1635b7a2",
  null
  
)

export default component.exports